import { env } from "@monorepo/env/dashboard";

export const BFF_URL = env.VITE_EXPERIENCE_API_URL;
export const ACCOUNT_UI_URL = env.VITE_ACCOUNT_UI_URL;

// Query param the auth-recovery fallback sets on /login so the page can
// explain why the user landed there. The value is the only recognized reason.
export const LOGIN_REASON_PARAM = "reason";
export const SESSION_EXPIRED_REASON = "session_expired";

export const HIDDEN_TOOLKITS = new Set([
  "google",
  "microsoft",
  "search",
  "web",
  "codesandbox",
  "notiontoolkit",
  "outlookcalendar",
  "outlookmail",
  "sharepoint",
]);
